/**
 * Button — лёгкая кнопка на классах theme.css (.pw-btn / .pw-btn--*).
 * Без внешних UI-китов. Варианты: primary (амо-синий), default (контурная), ghost (без рамки),
 * danger (для деструктивных действий). Размер sm — компактный.
 */

import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cx } from './cx';

export type ButtonVariant = 'primary' | 'default' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Иконка слева от текста. */
  icon?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'default', size = 'md', icon, className, children, type, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={cx(
        'pw-btn',
        variant === 'primary' && 'pw-btn--primary',
        variant === 'ghost' && 'pw-btn--ghost',
        variant === 'danger' && 'pw-btn--danger',
        size === 'sm' && 'pw-btn--sm',
        className,
      )}
      {...rest}
    >
      {icon ? (
        <span className="pw-btn__icon" aria-hidden>
          {icon}
        </span>
      ) : null}
      {children}
    </button>
  );
});
